import { getStoredAdmin } from '@/services/api'
import { normalizePersian } from '@/components/common/SearchableSelect.vue'

const key = () => {
  const id = getStoredAdmin()?.id
  return id == null ? null : `moroorato.search.recent.v1.${id}`
}
export function readRecentSearches() {
  try {
    const storageKey = key()
    if (!storageKey) return []
    const value = JSON.parse(localStorage.getItem(storageKey))
    return Array.isArray(value) ? value.filter(item => typeof item === 'string' && item.trim() && item.length <= 120).slice(0, 5) : []
  } catch { return [] }
}
export function saveRecentSearch(term) {
  const text = term.trim().slice(0, 120)
  return writeRecentSearches(text ? [text, ...readRecentSearches().filter(item => normalizePersian(item) !== normalizePersian(text))].slice(0, 5) : readRecentSearches())
}
export function writeRecentSearches(items) {
  try { const storageKey = key(); if (storageKey) { if (items.length) localStorage.setItem(storageKey, JSON.stringify(items)); else localStorage.removeItem(storageKey) } } catch { /* Search still works when storage is unavailable. */ }
  window.dispatchEvent(new Event('admin:recent-searches'))
  return items
}
